import * as v from 'valibot';
export const CommonValueBoolSchema = v.object({
    type: v.literal('bool'),
    value: v.boolean()
});
export const CommonValueIntSchema = v.object({
    type: v.literal('int'),
    value: v.number()
});
export const CommonValueRealSchema = v.object({
    type: v.literal('real'),
    value: v.number()
});
export const CommonValueEnumSchema = v.object({
    type: v.literal('enum'),
    value: v.string()
});
export const CommonValueSchema = v.union([CommonValueBoolSchema, CommonValueIntSchema, CommonValueRealSchema, CommonValueEnumSchema]);
export function prettyPrintValue(t) {
    switch (t.type) {
        case 'bool':
            return t.value ? 'true' : 'false';
        case 'int':
            {
                return t.value.toString();
            }
            ;
        case 'real':
            {
                return t.value.toString();
            }
            ;
        case 'enum':
            return t.value;
    }
}
